import request from '@/utils/request'

// 新增任务
export function addTask(reqParams) {
  return request({
    url: `task/add`,
    method: 'post',
    data: reqParams
  })
}

// 提交
export function submitRejectForm(reqParams) {
  return request({
    url: `task/reject`,
    method: 'post',
    data: reqParams
  })
}

// 所属产品下拉框的url http://120.237.80.132:8083/api/task/addTaskSelect
export function getProject() {
  return request({
    url: 'task/addTaskSelect',
    method: 'get'
  })
}

// 所有模块下拉框的url http://120.237.80.132:8083/api/task/addTaskSelect
export function getModel(projectId) {
  return request({
    url: `task/addTaskSelect?project_id=${projectId}`,
    method: 'get'
  })
}

// 影响版本 下拉框的url http://120.237.80.132:8083/api/task/addTaskSelect
export function getVersion() {
  return request({
    url: `task/addTaskSelect?pv_id=1`,
    method: 'get'
  })
}

// 解决版本 下拉框的url http://120.237.80.132:8083/api/task/addTaskSelect
export function getSolveVersion(projectId) {
  return request({
    url: `task/addTaskSelect?project_id=${projectId}&pv_id_future=1`,
    method: 'get'
  })
}

// 相关需求 下拉框的url http://120.237.80.132:8083/api/task/addTaskSelect
export function getDemand(pmId) {
  return request({
    url: `task/addTaskSelect?pm_id=${pmId}`,
    method: 'get'
  })
}

// 相关任务下拉框的url http://120.237.80.132:8083/api/task/addTaskSelect
export function getTaskList(demandId) {
  return request({
    url: `task/addTaskSelect?demand_id=${demandId}`,
    method: 'get'
  })
}

// 驳回信息
export function getTask(taskId) {
  return request({
    url: `task/reject?task_id=${taskId}`,
    method: 'get'
  })
}

// 查询缺陷管理列表--分页数据
export function getDefectList(form) {
  return request({
    url: 'task/bugList',
    method: 'post',
    data: form
  })
}
